import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import './App.css';

// Layout components
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import FeedbackForm from './components/FeedbackForm';
import GetintouchandContact from './components/getintouchandcontact';

// Page components
import HomePage from './pages/HomePage';
import AboutPage from './pages/AboutPage';
import VisionPage from './pages/VisionPage';
import CareersPage from './pages/CareersPage';
import ContactPage from './pages/ContactPage';
import PrivacyPage from './pages/PrivacyPage';
import TermsPage from './pages/TermsPage';
import ProductPage from './pages/ProductPage';

// Admin components
import AdminLogin from './components/AdminLogin';
import AdminDashboard from './components/AdminDashboard';

// Hooks
import useAdminSessionCheck from './hooks/useAdminSessionCheck';

// Layout wrapper for main site pages
const MainLayout = ({ children }) => {
  useAdminSessionCheck();
  
  return (
    <>
      <Navbar />
      {children}
      <Footer />
      <FeedbackForm />
      <GetintouchandContact />
    </>
  );
};

function App() {
  return (
    <div className="App">
      <Router>
        <Routes>
          <Route path="/" element={<MainLayout><HomePage /></MainLayout>} />
          <Route path="/about" element={<MainLayout><AboutPage /></MainLayout>} />
          <Route path="/vision" element={<MainLayout><VisionPage /></MainLayout>} />
          <Route path="/careers" element={<MainLayout><CareersPage /></MainLayout>} />
          <Route path="/contact" element={<MainLayout><ContactPage /></MainLayout>} />
          <Route path="/privacy" element={<MainLayout><PrivacyPage /></MainLayout>} />
          <Route path="/terms" element={<MainLayout><TermsPage /></MainLayout>} />
          <Route path="/rusiv" element={<MainLayout><ProductPage /></MainLayout>} />
          <Route path="/admin/login" element={<AdminLogin />} />
          <Route path="/admin" element={<AdminDashboard />} />
          <Route path="*" element={<MainLayout><HomePage /></MainLayout>} />
        </Routes>
      </Router>
    </div>
  );
}

export default App;